import { Skeleton } from "@mui/material";

import { type IconSize } from "../CbhIcon";

interface CbhIconSkeletonProps {
  size?: IconSize;
}

export function CbhIconSkeleton(props: CbhIconSkeletonProps) {
  const { size = "medium" } = props;

  return (
    <Skeleton
      variant="circular"
      sx={(theme) => ({
        width: theme.size?.icon[size],
        height: theme.size?.icon[size],
      })}
    />
  );
}
